<h2 mat-dialog-title>
    <mat-icon>warning</mat-icon>
    Excluir este registro?
</h2>
<mat-dialog-content>
    @if (data.allowTemporary) {
    <button mat-stroked-button color="accent" [mat-dialog-close]="tempResult">
        Excluir temporáriamente
    </button>
    } @if (data.allowPermanent) {
    <button mat-stroked-button color="warn" [mat-dialog-close]="permResult">
        Excluir permanentemente
    </button>
    }
    <button mat-button mat-dialog-close>Voltar</button>
</mat-dialog-content>
